// API resources
import advisory from '@/api/modules/advisory'

// Mutations
import {
  ADD_ADVISORS_LIST,
  RESET_MODULE
} from '@/store/mutation-types'

// Default state
const getDefaultState = () => {
  return {
    list: []
  }
}
const state = getDefaultState()

// ----------------------------------------------------------------------

const actions = {
  fetch (context, cached = true) {
    if (cached && context.state.list.length !== 0) {
      return Promise.resolve()
    }

    return advisory.getAdvisors()
      .then(data => context.commit(ADD_ADVISORS_LIST, data.availableAdvisors))
  },

  resetState (context) {
    context.commit(RESET_MODULE)
  }
}

const mutations = {
  [ADD_ADVISORS_LIST] (state, data) {
    state.list = data
  },

  [RESET_MODULE] (state) {
    Object.assign(state, getDefaultState())
  }
}

export default () => ({
  namespaced: true,
  state,
  actions,
  mutations
})
